// Version check utility — detects when the running bundle is behind the server
// and records it for observability. It deliberately does NOT prompt the user:
// assets are content-hashed + immutable and the service worker doesn't cache
// them, so a stale bundle keeps working and the user silently picks up the new
// version on their next full navigation/reload. A visible "🔄 有新版本" toast on
// every deploy was disproportionate for a frequently-deployed kids' app (and now
// fired on backend-only/docs deploys too, since the version is the git sha), so
// it's been removed in favour of the standard silent-update behaviour.

import { trackVersionMismatch } from './posthogEvents';

// Build version (git sha) injected at build time
const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION || 'dev';

let hasTrackedMismatch = false;

/**
 * Check whether the running bundle matches the server's deployed version.
 * Call this after API responses to detect (and record) stale clients. Fires the
 * PostHog mismatch event at most once per session and shows no UI — the update
 * is delivered silently on the user's next reload.
 */
export function checkVersion(serverVersion) {
  if (!serverVersion || serverVersion === 'dev' || BUILD_VERSION === 'dev') {
    return; // Skip in dev mode
  }

  if (serverVersion !== BUILD_VERSION && !hasTrackedMismatch) {
    hasTrackedMismatch = true;
    console.warn(`[VersionCheck] Client version ${BUILD_VERSION} differs from server ${serverVersion}`);

    // Track version drift for observability — high drift = deploy propagation
    // issue or users on stale bundles for extended periods.
    trackVersionMismatch({
      clientVersion: BUILD_VERSION,
      serverVersion,
    });
  }
}

/**
 * Get the current build version
 */
export function getBuildVersion() {
  return BUILD_VERSION;
}
